module.exports = __webpack_public_path__ + "img/certif_019.70e3b576.jpg";